import { Injectable, inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
import { ZustimmungStatusResponse, ZustimmungSavedResponse } from '../models/api.models';

@Injectable({ providedIn: 'root' })
export class ZustimmungService {
  private authService = inject(AuthService);

  private getApiUrl(): string {
    const cfg = environment.controlCenter;
    return window.location.hostname === 'localhost'
      ? 'http://localhost:8000'
      : cfg.apiUrl;
  }

  async getStatus(): Promise<ZustimmungStatusResponse> {
    const token = await this.authService.getToken();
    if (!token) throw new Error('Zustimmung-Check ohne gültige Sitzung nicht möglich');
    const params = new URLSearchParams({
      environment: environment.controlCenter.environmentName,
      labsProject: 'Preisradar'
    });
    const res = await fetch(`${this.getApiUrl()}/api/zustimmung?${params}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!res.ok) throw new Error(`Zustimmung-Check fehlgeschlagen (${res.status})`);
    return res.json();
  }

  async save(): Promise<ZustimmungSavedResponse> {
    const token = await this.authService.getToken();
    if (!token) throw new Error('Zustimmung speichern ohne gültige Sitzung nicht möglich');
    const res = await fetch(`${this.getApiUrl()}/api/zustimmung`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        environment: environment.controlCenter.environmentName,
        labsProject: 'Preisradar'
      })
    });
    if (!res.ok) throw new Error(`Zustimmung speichern fehlgeschlagen (${res.status})`);
    return res.json();
  }
}
